import React from "react";
import { useLocation } from "react-router-dom";
import CustomerDetailPage from "./CustomerDetailPage";

/**
 * Wrapper component for CustomerDetailPage that handles initial data from navigation state
 * This allows the page to reuse data from the users list without making additional API calls
 */
const CustomerDetailWrapper = () => {
  const location = useLocation();
  const initialUser = location.state?.user;

  return <CustomerDetailPage initialUser={initialUser} basePath="/users" />;
};

export default CustomerDetailWrapper;
